<template>
  <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      :retain-focus="false"
      persistent
      transition="dialog-bottom-transition">
      <template v-slot:activator="{ on, attrs }">
          <v-btn 
            v-bind="attrs"
            v-on="on" 
            color="primary"
            dark>
            <v-icon left>mdi-plus</v-icon>
            {{ $t('mindset.label.addMindset.title') }}
          </v-btn>
      </template>
      <v-card>
        <v-toolbar
          dark
          color="secondary">
              <v-btn
                  icon
                  dark
                  class="btn btn-primary"
                  @click="closeDialog()">
                  <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>
                {{ this.$t('mindset.label.addMindset.title') }}
              </v-toolbar-title>
          </v-toolbar>
        <addMindsetComponent/>
      </v-card>
  </v-dialog>

</template>

<script>
import addMindsetComponent from '@/views/mindset/pages/add_mindset/components/form_add_mindset_component.vue';
import  EventBus  from '@/utils/event_bus.js'; 

export default {
  name:"addMindsetPage",
  components: {
    addMindsetComponent
  },
  data () {
    return {
      dialog: false
    }
  },
  watch: {
    dialog(newVal) {
      // Cuando el diálogo se cierra, emitir evento para limpiar el formulario
      if (!newVal) {
        EventBus.$emit('clear-mindset-form');
      }
    }
  },
  mounted() {
    EventBus.$on('addMindset-succesfull', () => {
      this.dialog = false;
    });
    EventBus.$on('mindset-error', () => {
      this.dialog = true;
    });
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      window.location.reload();
    }
  }
};
</script>

<style lang="css" scoped>
</style>
